export function changeLocationDepartureAction(location) {
    return {
        type: 'SEARCH_LOCATION_DEPARTURE_AIRFARE',
        payload: {
            locationDeparture: location
        }
    }
}

export function changeLocationArrivalAction(location) {
    return {
        type: 'SEARCH_LOCATION_ARRIVAL_AIRFARE',
        payload: {
            locationArrival: location
        }
    }
}

export function changeOnlyDepartureAction(boolean) {
    return {
        type: 'SEARCH_ONLY_DEPARTURE_AIRFARE',
        payload: {
            onlyDeparture: boolean
        }
    }
}

export function changeDatesAirfareAction(dates) {
    return {
        type: 'SEARCH_DATES_AIRFARE',
        payload: {
            datesSearchAirfare: dates
        }
    }
}

export const changeOfferAirfareAction = (data) => {
    return {
        type: 'SEARCH_OFFER_AIRFARE',
        payload: {
            offersAirfare: data
        }
    }
}

export const changePassengersAirfareAction = (data) => {
    return {
        type: 'SEARCH_PASSENGERS_AIRFARE',
        payload: {
            numberOfPassengers: data
        }
    }
}

export const changeClassAirfareAction = (data) => {
    return {
        type: 'SEARCH_CLASS_AIRFARE',
        payload: {
            classAirfare: data
        }
    }
}
